import { useGetByIdQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/noauth/ShortPublicChirpService.hooks';
import { useGetCatalogResourcesQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.hooks';
import { unwrapCatalogResourceShortFormContentChirpError, unwrapPublicShortFormContentChirpError } from './shortsUtils';
export const useShortFormContent = (shortId, skip) => {
  const {
    data,
    loading,
    error
  } = useGetCatalogResourcesQuery({
    variables: {
      requestedResources: [{
        resourceId: Number(shortId),
        type: 'SHORT_FORM_CONTENT'
      }]
    },
    skip
  });
  const {
    shortFormContent,
    shortFormContentError
  } = unwrapCatalogResourceShortFormContentChirpError({
    error,
    data
  });
  return {
    shortFormContent,
    shortFormContentLoading: loading,
    shortFormContentError
  };
};
export const useShortFormContentPublic = (shortId, skip) => {
  const {
    data,
    loading: shortFormContentLoading,
    error
  } = useGetByIdQuery({
    skip,
    variables: {
      contentId: Number(shortId)
    }
  });
  const {
    shortFormContent,
    shortFormContentError
  } = unwrapPublicShortFormContentChirpError({
    error,
    data
  });
  return {
    shortFormContent,
    shortFormContentLoading,
    shortFormContentError
  };
};